"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = Content;
exports.ContentContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _collection = require("../collection");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ContentContext = /*#__PURE__*/_react.default.createContext({});

exports.ContentContext = ContentContext;

function Content(_ref) {
  var children = _ref.children,
      _ref$displayType = _ref.displayType,
      displayType = _ref$displayType === void 0 ? 'light' : _ref$displayType,
      items = _ref.items;
  return /*#__PURE__*/_react.default.createElement(ContentContext.Provider, {
    value: {
      displayType: displayType
    }
  }, /*#__PURE__*/_react.default.createElement(_collection.Collection, {
    items: items
  }, children));
}